import { DRAFT_CHAT_MESSAGE } from '../../constants/superstoreStorageKeys';
import { getSuperStoreValue, setSuperstoreValue } from '../../utils/superStoreUtils';
export const getDraftMessageFromSuperstore = async () => {
  const draftMessage = await getSuperStoreValue(DRAFT_CHAT_MESSAGE);
  return draftMessage || '';
};
export const setDraftMessageInSuperstore = async message => {
  await setSuperstoreValue(DRAFT_CHAT_MESSAGE, message);
};